import { LoginJson } from "@/types/Auth.type";
import { JWT } from "next-auth/jwt";

export default function detectEmployee(data: JWT | LoginJson) {
	if (data?.company?.employee) {
		return true;
	}
	return false;
}
